export const isValidDate = (value: unknown): value is Date =>
  value instanceof Date && Number.isFinite(value.getTime());
